import { DeleteOutlined, FormOutlined } from '@ant-design/icons';
import { Spin, Tabs } from 'antd';
import _ from 'lodash';
import React, { useEffect } from 'react';
import { useDispatch } from 'react-redux';
import { useHistory, useParams } from 'react-router';
import { useIntersectionObserver, useMergeState } from '../../../utils/hooks';
import { toastrSuccess } from '../../../utils/toastNotification';
import NormalButton from '../../components/buttons/normalButton';
import InfoCard from '../../components/cards/infoCard';
import EditCardInformationModal from '../../components/modals/editCardInfo';
import InstructionModal from '../../components/modals/instructionModal';
import NormalTable from '../../components/tables/normalTable';
import {
  deleteCard, formatCardInformation, formatLocalChangeLogs, getChangeLogColumns, handleFetchEsimHistories, handleFetchEsimInfor,
} from './helper';
import displayLoading from '../../../redux/actions/loading';
import './style.scss';

const { TabPane } = Tabs;

const CardInformation = (props) => {
  const dispatch = useDispatch();
  const history = useHistory();
  const [state, setState] = useMergeState({
    isLoadingMore: false,
    selectedTab: 0,
    changeLogs: [],
    deleteVisible: false,
    editVisible: false,
    cardInfor: [],
    cursor: undefined,
    lastElement: undefined,
  });
  const tabs = [
    {
      key: '0',
      tabName: 'Change logs',
    },
  ];

  const changeLogColumns = getChangeLogColumns();
  const params = useParams();

  const handleLoadMore = async () => {
    if (state.isLoadingMore || !state.cursor) {
      return;
    }
    const listUsersFilterInput = { cursor: state.cursor, esimId: params.id };
    setState({ isLoadingMore: true });
    const changeLogs = await handleFetchEsimHistories(listUsersFilterInput, 20);
    setState({
      changeLogs: [...state.changeLogs, ...changeLogs],
      cursor: changeLogs.length < 20 ? undefined : changeLogs[changeLogs.length - 1]?.id || undefined,
    });
    setState({ isLoadingMore: false });
  };
  const toggleDeleteModal = () => {
    setState({ deleteVisible: !state.deleteVisible });
  };

  const toggleEditModal = () => {
    setState({ editVisible: !state.editVisible });
  };

  const onEditClick = () => {
    toggleEditModal();
  };

  const onDeleteClick = () => {
    toggleDeleteModal();
  };

  const onEditCard = (data, changeLogs) => {
    setState({ cardInfor: formatCardInformation(data), changeLogs: [...formatLocalChangeLogs(changeLogs), ...state.changeLogs] });
  };

  const onConfirmDelete = async () => {
    const deleteEsim = await deleteCard(params?.id);
    if (!deleteEsim?.isSuccess) {
      return;
    }
    history.replace('/card-license');
    toastrSuccess("Card's infomation deleted successfully");
  };


  const onTabChange = (key) => {
    setState({ selectedTab: key });
  };

  const renderTable = () => (
    <>
      <NormalTable
        dataSource={state.changeLogs}
        columns={changeLogColumns}
      />
      <div className="loadmore">
        {state.isLoadingMore && <Spin />}
      </div>
    </>
  );

  useEffect(() => {
    const fetchInitData = async () => {
      const initData = await Promise.all([handleFetchEsimInfor(params.id),
        handleFetchEsimHistories({ esimId: params.id }, 20)]);
      if (_.isEmpty(initData[0])) {
        history.replace('/card-license');
      }
      setState({ cardInfor: initData[0], changeLogs: initData[1], cursor: initData[1].length < 20 ? undefined : (initData[1])[initData[1]?.length - 1]?.id });
    };
    dispatch(displayLoading(true));
    fetchInitData();
    dispatch(displayLoading(false));
  }, []);


  useEffect(() => {
    if (!_.isEmpty(state.changeLogs)) {
      const rowElements = document.querySelectorAll('.ant-table-row-level-0');
      setState({ lastElement: rowElements[rowElements.length - 1] });
    }
  }, [state.changeLogs]);

  useIntersectionObserver(state.lastElement, handleLoadMore, () => {}, [state.changeLogs, state.cursor]);
  return (
    <div className="card-information">
      <div className="card-information-left">
        <div className="card-information-left-title">
          {state?.cardInfor?.info?.[0]?.title}
        </div>
        <div className="card-information-left-content">
          {state?.cardInfor?.info?.[0]?.data.map(row => (
            <div key={row.label} className="card-information-left-content-row">
              <div className="item">
                {`${row.label}`}
              </div>
              <div className="item item-value">
                {`${row.value}`}
              </div>
            </div>
          ))}
        </div>
      </div>
      <div className="card-information-right">
        <div className="card-information-right-header">
          <Tabs defaultActiveKey="0" onChange={onTabChange}>
            {_.map(tabs, x => (
              <TabPane tab={x.tabName} key={x.key} />
            ))}
          </Tabs>
          <div className="flex gap-12">
            <NormalButton
              text="Edit card's info"
              icon={<FormOutlined />}
              onClick={onEditClick}
            />
            <NormalButton
              text="Delete card"
              type="primary"
              icon={<DeleteOutlined />}
              onClick={onDeleteClick}
            />
          </div>
        </div>
        <div className="card-information-right-body">
          {renderTable()}
        </div>
      </div>
      <InstructionModal
        visible={state.deleteVisible}
        isWarning
        title="Do you want to delete the selected card?"
        description="The information of this card will be deleted permanently and user cannot use this card anymore."
        onCancel={toggleDeleteModal}
        onConfirm={onConfirmDelete}
      />
      <EditCardInformationModal
        visible={state.editVisible}
        onCancel={toggleEditModal}
        currentInfo={{ eId: state?.cardInfor?.info ? state.cardInfor.info[0].data : '', currentLicense: state.cardInfor.license }}
        onConfirm={onEditCard}
      />
    </div>
  );
};

export default CardInformation;
